const View = require("presto-ui").baseView;

class MobileHome2 extends View {

	constructor(props, children, state) {
		super(props, children, state);
		this.shouldCacheScreen = false;

		this.setIds(['Content']);

		this.style_Register = {
			onClick: this.onClickRegister.bind(this)
		}

		this.style_Forum = {
			onClick: this.onClickForum.bind(this)
		}

		this.style_LetsStartLink = {
			onClick: this.onClickLetsStart.bind(this)
		}

		this.style_LetsStartButton = {
			onClick: this.onClickLetsStart.bind(this)
		}

		this.style_JuspayVideo = {
			onClick: this.onClickVideo.bind(this)
		}
	}

	onClickLetsStart(){
		var cmd = this.cmd({id : this.idSet.Content, visibility: "gone"});
		Android.runInUI(cmd,null);
		document.getElementById("content").scrollTo(0,0);

		if (window.__WIDTH <=600)
			window.__duiShowScreen(null,{screen:"MobileSFP"});
		else
			window.__duiShowScreen(null,{screen:"SFP"});
	}

	onClickRegister() {
		window.open("https://form.jotform.co/73251234628858",'_blank');
	}

	onClickForum() {
		window.open("https://muut.com/purescript-presto",'_blank');
	}

	onClickVideo() {
		window.open("https://www.youtube.com/watch?v=ffzzXQI_i5s&feature=youtu.be",'_blank');
	}
}

module.exports = MobileHome2;



// WEBPACK FOOTER //
// ./controller/pages/Mobile/MobileHome2.js